import { FuelButton, FuelRadio, FuelTypography } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { PARTNER, riskManagementTextMap } from 'constants/risk-management';
import React, { FC, useState } from 'react';
import { DS_TOKENS } from 'constants/styled.contants';
import { useRiskManagement } from 'hooks/useRiskManagement';
import { useTruckerProps } from 'hooks/useTruckerProps';
import useHostGlobals from 'appHost/Globals';
import { SelectPartnerProps } from './types';
import CompaniesListModal from '../CompaniesListModal';
import * as Styled from './styled';

const SelectPartner: FC<SelectPartnerProps> = ({ partners, flowType }) => {
  const global = useHostGlobals();
  const [selectedOption, setSelectedOption] = useState(partners[0]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { titleLabel, buttonLabel } = riskManagementTextMap[flowType];
  const { navigateToRiskManagement } = useRiskManagement();
  const { freightId, truckerId, onClose } = useTruckerProps();

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const openWhatsApp = () => {
    window.open(
      encodeURI(
        'https://api.whatsapp.com/send/?phone=556492781445&text=Olá+represento+uma+empresa+e+gostaria+de+conversar+com+um+especialista+sobre+os+planos+e+preços+da+Fretebras&type=phone_number&app_absent=0'
      ),
      '_blank'
    );
  };

  const handleClick = () => {
    global?.dispatchToGlobal?.({ type: 'set_trucker_profile', payload: {} });

    onClose?.();

    navigateToRiskManagement(truckerId, freightId, selectedOption);
  };

  return (
    <>
      <FuelTypography size="body-md" weight="regular" color="neutral-default" spacingTop={32}>
        {titleLabel}
      </FuelTypography>

      <FuelFlex
        defaultProps={{ justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap' }}
        smProps={{ customPadding: `${DS_TOKENS.spacing.km4} 0 0 0` }}
      >
        <FuelFlex
          defaultProps={{
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: 'km6',
            customPadding: `${DS_TOKENS.padding.km4} 0 0 0`,
          }}
        >
          {partners.map((partner) => (
            <FuelRadio
              key={partner}
              label={PARTNER[partner]}
              checked={selectedOption === partner}
              onClick={() => setSelectedOption(partner)}
              data-testid={partner}
            />
          ))}
        </FuelFlex>
        <FuelFlex
          smProps={{ justifyContent: 'flex-start', width: '100%', customPadding: `${DS_TOKENS.spacing.km4} 0 0 0` }}
        >
          <FuelButton variant="secondary" size="small" onClick={handleClick}>
            {buttonLabel}
          </FuelButton>
        </FuelFlex>
      </FuelFlex>
      {partners.length === 1 && (
        <FuelTypography
          size="caption"
          weight="regular"
          color="neutral-default"
          spacingBottom={16}
          spacingTop={16}
          data-testid="one-partner-text"
        >
          <>
            Este motorista está cadastrado apenas na <Styled.StrongText>{PARTNER[partners[0]]}.</Styled.StrongText>{' '}
            <Styled.UnderlinedText onClick={handleOpenModal}>Ver outras GRs parceiras</Styled.UnderlinedText>
          </>
        </FuelTypography>
      )}

      <FuelTypography
        size="caption"
        weight="regular"
        color="neutral-default"
        spacingBottom={16}
        spacingTop={32}
        data-testid="security-label-text"
      >
        Todas as nossas consultas possuem validade securitária (em PDF) enviadas por nossas{' '}
        <Styled.UnderlinedText onClick={handleOpenModal}>GRs parceiras</Styled.UnderlinedText>. Em caso de dúvidas{' '}
        <Styled.UnderlinedText onClick={openWhatsApp} data-testid="specialist-link">
          fale com nossos especialistas.
        </Styled.UnderlinedText>
      </FuelTypography>
      <CompaniesListModal handleCloseModal={handleCloseModal} isModalOpen={isModalOpen} />
    </>
  );
};

export default SelectPartner;
